import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20red%20curtains%20with%20dramatic%20warm%20spotlight%2C%20dark%20velvet%20texture%2C%20golden%20film%20projector%20light%20beam%2C%20elegant%20premium%20cinema%20atmosphere%2C%20deep%20rich%20tones%20with%20subtle%20texture%20patterns&width=1800&height=900&seq=hero-bg-main-2025&orientation=landscape"
          alt="91免费高清影视平台"
          className="w-full h-full object-cover"
          title="91免费高清影视平台"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 md:px-6 text-center">
        <div className="mb-3">
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-500/20 backdrop-blur-sm text-primary-300 text-xs font-medium rounded-full border border-primary-400/20">
            <i className="ri-flashlight-line"></i>
            每日更新 · 高清免费
          </span>
        </div>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 font-heading leading-tight">
          海量高清影视
          <br />
          <span className="text-primary-400">免费在线观看</span>
        </h1>
        <p className="text-base md:text-lg text-white/70 mb-8 max-w-[600px] mx-auto leading-relaxed">
          91免费汇聚最新最全的免费电影资源，动作片、喜剧片、科幻片、动漫等海量内容，高清画质流畅播放，每日更新，随时随地畅享观影乐趣。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
          <Link
            to="/category"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap text-center shadow-lg shadow-primary-500/25"
          >
            <i className="ri-play-circle-line mr-2"></i>
            立即观影
          </Link>
          <Link
            to="/category?tab=资讯"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white text-sm font-medium rounded-full hover:bg-white/20 transition-all duration-300 cursor-pointer whitespace-nowrap text-center border border-white/20"
          >
            <i className="ri-article-line mr-2"></i>
            影视资讯
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 text-white/50 text-sm">
          <div className="flex items-center gap-2">
            <i className="ri-movie-2-line text-lg text-primary-400"></i>
            <span>10000+ 影视资源</span>
          </div>
          <div className="w-px h-4 bg-white/20"></div>
          <div className="flex items-center gap-2">
            <i className="ri-4k-line text-lg text-primary-400"></i>
            <span>4K 高清画质</span>
          </div>
          <div className="w-px h-4 bg-white/20"></div>
          <div className="flex items-center gap-2">
            <i className="ri-speed-up-line text-lg text-primary-400"></i>
            <span>极速播放</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-white/30 flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 rounded-full bg-white/60 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}